<script>
export default {
    name: "FullHeightComponent",
    props: {
        topbar_height: {
            type: Number,
            default: 44
        }
    },
    mounted() {
        // Обновляем высоту элемента при изменении размера окна
        this.updateHeight();
        window.addEventListener("resize", this.updateHeight);
    },
    beforeUnmount() {
        // Удаляем обработчик события при уничтожении компонента
        window.removeEventListener("resize", this.updateHeight);
    },
    methods: {
        isDesktop() {
            return window.innerWidth >= 1024; // Минимальная ширина для десктопа
        },
        updateHeight() {
            // if (this.isDesktop()) {
            //     const element = this.$el;
            //     if (element) {
            //         element.style.height = `${window.innerHeight - this.topbar_height}px`;
            //     }
            // }
        },
    }
}
</script>

<template>
    <section class="min-h-[100vh]">
        <slot/>
    </section>
</template>

<style scoped lang="scss">

</style>
